import { App } from 'data/terra/App';
import { AppConfig } from 'data/terra/AppConfig';
import { AppVersion } from 'data/terra/AppVersion';
import { Environment } from 'data/terra/Environment';
import { ServiceIntegration } from 'data/terra/ServiceIntegration';
import { getInitialResourceState, Resource } from '../common/Resource';
import { Product } from '../../../data/terra/Product';

export interface ProjectDetailState {
  selectedProjectId?: string;
  project: Resource<Product>;
  apps: Resource<App[]>;
  selectedApp?: App;
  appVersions: Resource<AppVersion[]>;
  selectedAppVersion?: AppVersion;
  selectedAppConfig?: AppConfig;
  appConfigs: Resource<AppConfig[]>;
  serviceIntegrations: Resource<ServiceIntegration[]>;
  selectedEnv?: Environment;
  uiConfig: UIConfig;
}

export const initialState: ProjectDetailState = {
  project: getInitialResourceState(),
  apps: getInitialResourceState(),
  selectedApp: undefined,
  appVersions: getInitialResourceState(),
  selectedAppVersion: undefined,
  appConfigs: getInitialResourceState(),
  serviceIntegrations: getInitialResourceState(),
  selectedEnv: undefined,
  uiConfig: getInitialUIConfig(),
};

export interface UIConfig {
  visibleSaveConfigButton: boolean;
  visibleSyncConfigButton: boolean;
}

function getInitialUIConfig(): UIConfig {
  return {
    visibleSaveConfigButton: false,
    visibleSyncConfigButton: false,
  };
}
